import React from 'react'
import DashboardKpiStatus from "components/DashboardKpiStatus";
import { overviewChartPalette } from "styles/theme";
import {
    Avatar,
    Box,
    Card,
    CardContent,
    Grid,
    Typography
} from '@mui/material'
import { CiCalendar } from 'react-icons/ci'
import { Loader, Error } from './common';
import { FaRupeeSign } from 'react-icons/fa';

const getKpiBg = (item) => {
    return item.bg;
};

const getIconBg = (item) => {
    return item.iconBg;
};

const FinancialKpis = ({ data, isLoading, isError }) => {


    const kpisArr = [
        {
            key: "totalABGOutstanding",
            label: (
                <>
                    Total ABG Outstanding
                    <br />
                    (₹ Lakhs)
                </>
            ),
            value: Number(data?.totalABGOutstanding || 0).toFixed(2),
            bg: "#F3E8FF",
            iconBg: overviewChartPalette.violet,
            icon: <FaRupeeSign />
        },
        {
            key: "totalPBGOutstanding",
            label: (
                <>
                    Total PBG Outstanding
                    <br />
                    (₹ Lakhs)
                </>
            ),
            value: Number(data?.totalPBGOutstanding || 0).toFixed(2),
            bg: "#DCFCE7",
            iconBg: overviewChartPalette.teal,
            icon: <FaRupeeSign />
        },
        {
            key: "totalRBGOutstanding",
            label: (
                <>
                    Total RBG Outstanding
                    <br />
                    (₹ Lakhs)
                </>
            ),
            value: Number(data?.totalRBGOutstanding || 0).toFixed(2),
            bg: "#FFE2E5",
            iconBg: overviewChartPalette.coral,
            icon: <FaRupeeSign />
        },
        {
            key: "totalActiveBGs",
            label: "Total Active BGs (Count)",
            value: data?.activeBGCount || 0,
            bg: "#F3E8FF",
            iconBg: overviewChartPalette.indigo,
            icon: <CiCalendar />
        },
        {
            key: "expiringIn30Days",
            label: "Expiring in 30 Days (All BGs)",
            value: data?.expiringIn30Days || 0,
            bg: "#FFE2E5",
            iconBg: overviewChartPalette.amber,
            icon: <CiCalendar />
        },
        {
            key: "expiringIn60And90Days",
            label: "Expiring in 60 and 90 Days (All BGs)",
            value: (data?.expiringIn60Days || 0) + (data?.expiringIn90Days || 0),
            bg: "#FFE2E5",
            iconBg: overviewChartPalette.cyan,
            icon: <CiCalendar />
        },
    ];


    const updatedKpis = kpisArr.map(item => ({
        ...item,

        // value: item.value
    }));

    return (
        <>
            <Box
                elevation={0}
                sx={{
                    borderRadius: "3px",
                    border: "1px solid #eef0f4",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    boxSizing: "border-box",
                    p: "20px",
                    maxHeight: { xs: "auto", md: "316px" },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 600,
                        fontSize: "15px",
                        lineHeight: "21px",
                        color: "#05004E",
                    }}
                >
                    Guarantee Intelligence
                </Typography>

                <Typography
                    sx={{
                        fontFamily: "Poppins, sans-serif",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "16px",
                        color: "#737791",
                        mb: 2,
                    }}>
                    Core financial indicators reflecting bank guarantee exposure, expiry risks, and active commitments.
                </Typography>

                {isLoading && <Loader isLoading={isLoading} />}
                {isError && <Error isError={isError} />}

                {!isLoading && !isError && (
                    <Grid
                        container
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
                            gap: 1.25,
                            width: "100%",
                            "& > .MuiGrid-root": { minWidth: 0, width: "auto", maxWidth: "none" },
                            "& .MuiCard-root": { transition: "border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease" },
                            "& .MuiCard-root:hover": { borderColor: "#CBD5E1", boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)", transform: "translateY(-1px)" },
                        }}
                    >
                        {updatedKpis?.map((item) => (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={4}
                                key={item.label}
                                sx={{
                                    minWidth: 0
                                }}
                            >
                                <Card
                                    elevation={0}
                                    sx={{
                                        height: "128px",
                                        position: "relative",
                                        borderRadius: "3px",
                                        backgroundColor: "#FFFFFF",
                                        border: "1px solid #E2E8F0",
                                        borderBottom: `3px solid ${getIconBg(item)}`,
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            gap: 1,
                                            p: 1.25,
                                            pt: 1.25
                                        }}
                                    >
                                        <Avatar
                                            sx={{
                                                width: 30,
                                                height: 30,
                                                backgroundColor: getIconBg(item),
                                                fontSize: 18,
                                                fontWeight: 700,
                                            }}
                                        >
                                            {item.icon}
                                        </Avatar>
                                        <DashboardKpiStatus color={getIconBg(item)} />

                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "13px",
                                                mt: "4px",
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 600,
                                                    fontSize: "16px",
                                                    lineHeight: "21px",
                                                    color: "#151D48",
                                                }}
                                            >
                                                {item.value}
                                            </Typography>
                                        </Box>

                                        <Typography
                                            sx={{
                                                fontFamily: "Outfit, sans-serif",
                                                fontWeight: 500,
                                                lineHeight: "16px",
                                                fontSize: "12px",
                                                color: "#425166",
                                                mt: "4px",
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>
        </>
    )
}

export default FinancialKpis;
